// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function objectToFormData(obj: any, formData: FormData = new FormData(), parentKey: string = ''): FormData {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      
      // Si el valor es un objeto o array, lo convertimos en string (JSON)
      if (value && typeof value === 'object' && !(value instanceof File)) {
        formData.append(parentKey ? `${parentKey}[${key}]` : key, JSON.stringify(value));
      } else {
        // Si es un valor primitivo (string, number, etc.), lo agregamos directamente
        formData.append(parentKey ? `${parentKey}[${key}]` : key, value);
      }
    }
  }

  return formData;
}